<template>
    <div class="device-list table-responsive text-center my-2">
        <table class="table table-bordered table-sm mb-0">
            <thead class="bg-hub-primary text-white sticky-top">
                <tr>
                    <th class="text-left">Name</th>
                    <th>Extension</th>
                    <th>Edit</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="device in sorted_devices" :class="hasExtension(device) && !device.registered ? 'unregistered' : ''">
                    <td class="text-left">
                        <i v-if="machine_type === 'Box' && device.online" class="far fa-check-circle online" aria-hidden="true"></i>
                        <i v-else-if="machine_type === 'Box' && !device.online" class="far fa-times-circle offline" aria-hidden="true"></i>
                        {{ device.name }}
                    </td>
                    <td v-if="hasExtension(device)">
                        <span v-if="device.registered" class="registered"
                        >{{ device.extension }}
                        <i class="fa fa-phone fa-fw" aria-hidden="true"></i
                        ></span>
                        <span class="not-registered" v-else
                        >{{ device.extension }}
                        <i class="fa fa-phone-slash fa-fw" aria-hidden="true"></i
                        ></span>
                    </td>
                    <td v-else>N/A</td>
                    <td >
                        <button class="btn btn-sm w-100" @click="handleEditClick" :id="device.device_id">
                            <i class="fa fa-pencil-alt fa-fw" aria-hidden="true"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash'
import { DEVICE_TYPE } from '../../../assets/js/resource-types';

export default {
    props: ['devices', 'callback'],
    computed: {
        ...mapGetters({
            machine_type: 'machineType',
        }),
        sorted_devices() {
            const deviceTypeOrder = (device) => this.hasExtension(device) ? 0 : device.device_type_id;
            return _.orderBy(this.devices, [deviceTypeOrder, 'registered'], ['asc', 'asc'])
        }
    },
    methods: {
        hasExtension(device) {
            return device.extension !== null && device.extension !== '' && device.extension !== 0
        },
        handleEditClick(e) {
            this.callback && this.callback(e.currentTarget.id);
        }
    }
}
</script>

<style>
.device-list {
    max-height: 35vh;
    border: 1px solid #ccc;
}

.registered, .online {
  color: green;
}

.not-registered, .offline {
    color: red;
}

.registered, .not-registered {
  font-weight: bold;
}
</style>